import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Icon from 'react/components/Icon';

class ButtonWithIcon extends Component {
  constructor(props) {
    super(props);
    this.state = { hovered: false };
  }

  mouseEnter = () => {
    this.setState({
      hovered: true
    });
  }

  mouseLeave = () => {
    this.setState({
      hovered: false
    });
  }

  getUrl = () => {
    const {
      iconUrl, activeIconUrl, isActive, changeOnlySelected = false
    } = this.props;

    const { hovered } = this.state;

    if (isActive || (hovered && !changeOnlySelected)) {
      return activeIconUrl;
    }

    return iconUrl;
  }

  render() {
    const {
      style,
      styles,
      label,
      onClick,
      isActive,
      activeBackground,
      children,
      testid
    } = this.props;

    const url = this.getUrl();

    return (
      <span
        data-testid={testid}
        className="button-with-icon-component"
        style={style || styles.base}
        onClick={onClick}
        onMouseEnter={this.mouseEnter}
        onMouseLeave={this.mouseLeave}
      >
        {children || (
          <Icon
            iconUrl={url}
            style={isActive && activeBackground
              ? { ...styles.icon, backgroundColor: activeBackground } : styles.icon}
          />
        )}
        <span
          className="button-with-icon-label-component"
          style={styles.label}
        >
          {label}
        </span>
      </span>
    );
  }
}

ButtonWithIcon.propTypes = {
  testid: PropTypes.string,
  label: PropTypes.string.isRequired,
  onClick: PropTypes.func,
  style: PropTypes.object,
  styles: PropTypes.object,
  iconUrl: PropTypes.string,
  activeIconUrl: PropTypes.string,
  isActive: PropTypes.bool,
  activeBackground: PropTypes.string,
  changeOnlySelected: PropTypes.bool,
  children: PropTypes.element
};

ButtonWithIcon.defaultProps = {
  testid: 'button-with-icon',
  styles: {},
  iconUrl: '',
  isActive: false,
  onClick: () => {},
  style: null,
  activeIconUrl: '',
  activeBackground: '',
  changeOnlySelected: false,
  children: null
};

export default ButtonWithIcon;
